<template>
    <search-box
        :default-focus-index="-1"
        :init-value="initValue"
        isAsync
        :isLoading="(suggestionsRequest && suggestionsRequest === 'request')"
        :isError="(suggestionsRequest && suggestionsRequest === 'failure')"
        :error="suggestionError && suggestionError"
        :filtered-items="asyncSuggestion"
        :placeholder="placeholderText ? placeholderText : $t(`UI.searchBox.placeholder`)"
        @submit="handleSearchBoxSubmit"
        @selectItem="handleSelectItem"
        @getItems="fetchSuggestions"
        @reset="handleReset"
        @input="setSuggestionValue"
        @open="onOpen"
        :showBack="showBack"
        @back="goBack"
        classNamePrefix=""
        :formClass="formClass"
        :inputClass="inputClass"
        :iconClass="iconClass"
        :resultsClass="resultsClass"
        :outerWrapperClassname="outerWrapperClassname">
        <template v-slot:afterInputSlot>
            <slot name="afterInputSlot" />
        </template>
    </search-box>
</template>

<script>
import SearchBox from "@/components/ui/SearchBox/SearchBox";

export default {
    props: {
        placeholderText: {type: String, default: null},
        onSearch: { type: Function },
        showBack: {type: Boolean, default: false},

        formClass: {type: String, default: 'searchbox__wrapper'},
        inputClass: {type: String, default: 'searchbox-input--mm'},
        iconClass: {type: String, default: 'searchbox-icon--mm'},
        resultsClass: {type: String, default: 'searchbox__results searchbox__results--banner'},
        outerWrapperClassname: {type: String, default: ''},

        apiSearchOperation: {type: Function, required: true},
        transform: {type: Function, required: false},
        onSelectItem: {type: Function, required: true},

        minSearchValLength: {type: Number, default: null}
    },
    data(){
        return {
            initValue: "",
            asyncSuggestion: [],
            searchRequestState: null,
            suggestionsRequest: null,
            suggestionError: null
        };
    },
    components: {
        SearchBox
    },
    methods: {
        search(searchValue) {
            this.suggestionsRequest = 'request';

            if (this.minSearchValLength && (!searchValue || searchValue.length < this.minSearchValLength)) {
                this.suggestionError = this.$tc(`UI.searchBox.minSearchLength`, this.minSearchValLength);
                this.suggestionsRequest = "failure";
                return;
            }

            var promiseCall = this.apiSearchOperation(searchValue);

            promiseCall.then(res => {
                if (this.transform) {
                    this.asyncSuggestion = this.transform(res);
                } else {
                    this.asyncSuggestion = res;
                }
                this.suggestionsRequest = "success";
            });

            if (promiseCall && promiseCall.catch) {
                promiseCall.catch(() => {
                    this.suggestionError= this.$t(`UI.searchBox.searchError`);
                    this.suggestionsRequest = "failure";
                });
            }

            if (promiseCall && promiseCall.fail) {
                promiseCall.fail(() => {
                    this.suggestionError= this.$t(`UI.searchBox.searchError`);
                    this.suggestionsRequest = "failure";
                });
            }
        },
        goBack() {
            console.log("GO BACK");
        },
        onOpen(val) {
            this.search(val);
        },
        handleReset() {
            console.log('handleReset:');
        },
        handleSelectItem(item) {
            //alert('SELECT');
            this.onSelectItem(item);
            this.initValue = "";
        },
        handleSearchBoxSubmit(val) {
            //alert('WTF');
            console.log('handleSearchBoxSubmit', val);
        },
        fetchSuggestions(val) {
            this.search(val);
        },
        setSuggestionValue(val) {
            this.initValue = val;
            console.log('setSuggestionValue: ', val);
        }
    }
}
</script>


